// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"rotation"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 20C12 15.5818 8.41828 12 4 12M3 3V21H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RotationIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'rotation',
    ref,
    icon: element,
  },
));

RotationIcon.displayName = 'RotationIcon';

export default RotationIcon;
